import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  Stack,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import CusInput from '../../../../../components/material-ui/CusInput';
import CusButton from '../../../../../components/material-ui/CusButton';
import { useTranslation } from 'react-i18next';
import MyTableCell from '../../../../../components/material-ui/adaptive/MyTableCell';
import BtnTrash from '../../../../../components/bonus/ui/BtnTrash';
import ConfirmDialog from '../../../../../components/shared/ConfirmDialog';
import ShowContainer from '../../../../../components/material-ui/ShowContainer';
import MyTableBoldCell from '../../../../../components/material-ui/adaptive/MyTableBoldCell';
import CollectionCasino from './CollectionCasino';
import AddNewCollection from '../modal/AddNewCollection';
import CasinoUsedCollection from '../modal/CasinoUsedCollection';
import { useAppSelector } from '../../../../../store';
import CollectionRow from './CollectionRow';
import { ENUM_CURRENCY } from '../../../../../components/shared/CurrencySelect';

export default function CollectionsList({
  selectCollectionId,
  deleteCollection,
  setSelectCollectionId,
  addCollection,
  updateCasinos,
  getCollectionInfo,
  tableContainerRef,
  currentCollectionRef,
  editCollection
}) {
  const { t } = useTranslation();
  const collections = useAppSelector((state) => state.gameProviders.collections);
  const casinos = useAppSelector((state) => state.gameProviders.allCasino);
  const curCollection = collections.find((el) => el.id == selectCollectionId);

  const [selectedIds, setSelectedIds] = useState({ type: 'include', ids: new Set() });
  const [openDelete, setOpenDelete] = useState(false);
  const [modalCasinoInfoId, setModalCasinoInfoId] = useState(false);
  const [openNewCollection, setOpenNewCollection] = useState(false);
  const [editInfo, setEditInfo] = useState(false);

  const currentNameRef = useRef('');
  const currentCurrenciesRef = useRef([]);

  const curCollectionId = curCollection?.id;
  const casinoListStr = curCollection?.casinoList?.join(',');

  useEffect(() => {
    if (!curCollectionId) return;

    setSelectedIds({ type: 'include', ids: new Set(curCollection.casinoList) });
  }, [curCollectionId, casinoListStr]);

  return (
    <>
      <Stack gap={1}>
        <Stack gap={0.75}>
          <ShowContainer condition={collections.length}>
            <TableContainer
              ref={tableContainerRef}
              sx={{
                minHeight: `200px`,
                maxHeight: 'calc( 33svh - 100px)',
                scrollMarginTop: '50px'
              }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <MyTableBoldCell isLess sx={{ border: 'none', pb: 1, pt: 0 }}>
                      <Typography fontSize={16} fontWeight={900}>
                        {t('List of collections')}
                      </Typography>
                    </MyTableBoldCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {collections.map((collection) => (
                    <CollectionRow
                      currentCollectionRef={currentCollectionRef}
                      currentNameRef={currentNameRef}
                      currentCurrenciesRef={currentCurrenciesRef}
                      key={collection.id}
                      collection={collection}
                      selectCollectionId={selectCollectionId}
                      setSelectCollectionId={setSelectCollectionId}
                      setOpenDelete={setOpenDelete}
                      setEditInfo={setEditInfo}
                    />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </ShowContainer>

          <CusButton
            fullWidth
            text="Create a new collection"
            onClick={() => {
              setOpenNewCollection(true);
              setSelectCollectionId(null);
            }}
          />
        </Stack>
        <Stack display={'flex'} direction={'column'} gap={1}>
          <CollectionCasino
            rowCount={5}
            casinos={casinos}
            selectCollectionId={selectCollectionId}
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
            // readOnlyCheckBox
            onRowClick={(params) => setModalCasinoInfoId(params.row.id)}
            checkboxSelection={true}
          />

          <ShowContainer condition={selectCollectionId}>
            <CusButton
              fullWidth
              text="Save"
              variant="contained"
              color="primary"
              onClick={() => {
                editCollection(selectCollectionId, {
                  casinoList: Array.from(selectedIds?.ids),
                  name: curCollection?.name,
                  currencyList: curCollection?.currencyList
                });
              }}
            />
          </ShowContainer>
        </Stack>
      </Stack>

      <CasinoUsedCollection
        open={!!modalCasinoInfoId}
        casinos={casinos}
        collectionList={collections}
        modalCasinoInfoId={modalCasinoInfoId}
        onClose={() => setModalCasinoInfoId(0)}
        updateCasinos={updateCasinos}
        setSelectCollectionId={setSelectCollectionId}
      />

      <ConfirmDialog
        open={openDelete}
        title={t('Confirm deletion')}
        content={t('Are you sure you want to delete this item? This action cannot be undone.')}
        onClose={() => setOpenDelete(false)}
        onConfirm={() => deleteCollection(openDelete)}
      />

      <AddNewCollection
        casinos={casinos}
        openNewCollection={openNewCollection || editInfo}
        editInfo={editInfo}
        addCollection={addCollection}
        setEditInfo={setEditInfo}
        setOpenNewCollection={setOpenNewCollection}
        editCollection={editCollection}
        getCollectionInfo={getCollectionInfo}
      />
    </>
  );
}
